export default __webpack_public_path__ + "static/media/step-3.2eae607b.png";